import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSession } from '../../context/SessionContext';

export default function CategoryList({ isHome }) {
    const { brands = [], models = [] } = useSession();

    const combined = useMemo(() => {
        const brandItems = brands.map(item => ({ ...item, type: 'brand' }));
        if (isHome) {
            return brandItems;
        }
        const modelItems = models.map(item => ({ ...item, type: 'model' }));
        return [...brandItems, ...modelItems];
    }, [brands, models, isHome]);
    
    combined.sort((a, b) => a.name.localeCompare(b.name));

    return (
        <section className="py-9 mb-9 bg-background-light dark:bg-background-dark">
            <div className="container mx-auto px-4">
                <div className="text-center mb-10">
                    <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
                        Filter by Models &amp; Brands
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 mt-2">
                        Quickly find the products you're looking for.
                    </p>
                    <div className="mt-3 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                </div>

                <div className="bg-white dark:bg-slate-900 p-6 sm:p-8 rounded-lg shadow-md border">
                    {combined.length === 0 ? (
                        <p className="text-gray-500 text-center">No brands or models available.</p>
                    ) : (
                        <div className="flex flex-wrap justify-center gap-x-6 sm:gap-x-8 gap-y-3">
                            {combined.map((item) => (
                                <Link
                                    key={`${item.type}-${item.id}`}
                                    to={`/products?${item.type === 'brand' ? 'brand' : 'model'}=${item.id}`}
                                    className="font-medium text-gray-700 dark:text-gray-300 hover:text-secondary dark:hover:text-secondary transition-colors duration-200"
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}